/**
 * Created by lxhfight on 2018/4/8.
 * Email:
 * Description:
 *
 */
export const DATE_TIMESTAMP = 24 * 60 * 60 * 1000

export const compareDate = (str1, str2) => {
  const _getDateTimeStamp = (dateStr) => {
    const date = new Date(dateStr)
    const str = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    return new Date(str).getTime()
  }
  const date1 = _getDateTimeStamp(str1)
  const date2 = _getDateTimeStamp(str2)
  return Math.floor((date1 - date2) / DATE_TIMESTAMP)
}

export const getSmartDate = (str) => {
  if (!str) {
    console.warn('the param is undefined or null', str)
    return '-'
  }
  let datetime = `${str.split(' ')[0].split('-').join('/')} ${str.split(' ')[1]}`
  let year = new Date(datetime).getFullYear()
  let month = new Date(datetime).getMonth() + 1
  let date = new Date(datetime).getDate() >= 10 ? new Date(datetime).getDate() : `0${new Date(datetime).getDate()}`
  let hour = new Date(datetime).getHours() >= 10 ? new Date(datetime).getHours() : `0${new Date(datetime).getHours()}`
  let minute = new Date(datetime).getMinutes() >= 10 ? new Date(datetime).getMinutes() : `0${new Date(datetime).getMinutes()}`
  let count = compareDate(new Date(), datetime)
  const onlyDate = (new Date().getFullYear()) === year
  switch (count) {
    case 0:
      return `${hour}:${minute}`
    case 1:
      return `昨天 ${hour}:${minute}`
    case 2:
      return `前天 ${hour}:${minute}`
    default:
      return onlyDate ? `${month >= 10 ? month : '0' + month}.${date} ${hour}:${minute}`
        : `${year}.${month >= 10 ? month : '0' + month}.${date}`
  }
}

export const getDate = (str, format) => {
  let date
  (str) ? date = new Date(str.replace(/-/g, '/')) : date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`
  if (format.indexOf('-') !== -1) {
    return `${year}-${month >= 10 ? month : '0' + month}-${day}`
  } else if (format.indexOf('/') !== -1) {
    return `${year}/${month >= 10 ? month : '0' + month}/${day}`
  } else if (format.indexOf('.') !== -1) {
    return `${year}.${month >= 10 ? month : '0' + month}.${day}`
  }
}

export const dateStandard = (dateStr, isReg = false) => {
  let rtn = ''
  if (dateStr) {
    let str = dateStr.toString()
    str = str.replace(/\//g, '-')
    const a = str.split(' ')
    const d = a[0] ? a[0].split('-') : [0, 0, 0]
    const t = a[1] ? a[1].split(':') : [0, 0, 0]
    let date = new Date(d[0], (d[1] - 1), d[2], t[0], t[1], t[2])
    if (isReg) {
      (date = new Date(date.getTime() + (15 * 24 * 60 * 60 * 1000)))
    }
    rtn = date
  }
  return rtn
}

/**
 * 獲取時間戳對應的文本形式日期
 * @param {*} timestamp
 * @param {*} spliter
 * @returns {String}
 */
export const getDateString = (timestamp, spliter = '-') => {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2) // 月份是从0开始的，所以需要+1
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}${spliter}${month}${spliter}${day}`
}

/**
 * 獲取時間戳對應的中文文本形式日期
 * @param {*} timestamp
 * @param {*} spliter
 * @returns {String}
 */
export const getDateLocaleString = (timestamp) => {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2) // 月份是从0开始的，所以需要+1
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}年${month}月${day}日`
}

export const getLastDayOfMonth = (timestamp) => {
  // 创建一个Date对象
  const date = new Date(timestamp)
  // 将日期设置为下个月的第0天，这会自动回滚到当前月的最后一天
  date.setMonth(date.getMonth() + 1, 0)
  // 返回最后一天的日期
  return date.getDate()
}

/**
 * 獲取距離今天第幾天的日期（包含今天）
 */
export const getDateFromToday = (num = 0) => {
  let time = Date.now() + num * 1000 * 60 * 60 * 24
  return getDateString(time, '/')
}

/**
 * 計算今天距離目標日期還剩多少天
 * @param {String|Date} targetDate - 目標日期（字符串格式如 '2024-07-26' 或 Date 對象）
 * @returns {Number} 剩餘天數（未來返回正數，已過返回負數，當天返回0）
 */
export const getDaysRemaining = (targetDate) => {
  return compareDate(targetDate, new Date())
}
